module.exports = __webpack_public_path__ + "static/media/3.2417864f.jpg";